import createActions from 'utils/redux/createActions'

export default createActions([
	'COMMENT_ADD'
  , 'COMMENT_CHANGE'
  , 'COMMENT_SAVE'
  , 'COMMENT_DELETE'
  , 'COMMENT_DELETE_YES'
  , 'COMMENT_DELETE_NO'
  , 'COMMENT_EDIT'
  , 'COMMENT_DISCARD'
  , 'COMMENT_DONE'
  , 'COMMENT_UNDONE'
  , 'COMMENT_READ'
])



// WEBPACK FOOTER //
// ./src/actions/commentActions.js